import startCase from 'lodash/startCase'
import { useHistory } from 'react-router-dom'

import { PlanName, PlanRenewalType } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { isPlanDowngrade } from './utils'

const getVariant = (targetPlan: PlanName, currentPlan: PlanName) => {
  const isSamePlan = currentPlan === targetPlan
  const isDowngrade = isPlanDowngrade(targetPlan, currentPlan)

  if (isSamePlan) return 'outline'
  if (isDowngrade) return 'secondary'
  return 'primary'
}

const getButtonText = (targetPlan: PlanName, currentPlan: PlanName) => {
  const isSamePlan = currentPlan === targetPlan
  const isDowngrade = isPlanDowngrade(targetPlan, currentPlan)

  if (isSamePlan) return 'Your current plan'
  if (isDowngrade) return 'Contact us'
  return `Get ${startCase(targetPlan)}`
}

export const PlanCardButton = ({
  planName,
  renewalType,
}: {
  planName: PlanName
  renewalType: PlanRenewalType
}) => {
  const { data: network } = useNetwork()
  const history = useHistory()
  const currentPlan = network?.subscriptionPlan?.name
  const isSamePlan = currentPlan === planName
  const isDowngrade = isPlanDowngrade(planName, currentPlan)

  const handleClick = () => {
    if (isSamePlan || isDowngrade) return
    history.push({
      pathname: '/manage/settings/billing/purchase',
      search: `?plan=${planName}&renewalType=${renewalType}`,
    })
  }

  return (
    <Button
      fullWidth
      disabled={isSamePlan}
      variant={getVariant(planName, currentPlan)}
      onClick={() => handleClick()}
    >
      {getButtonText(planName, currentPlan)}
    </Button>
  )
}
